/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
// import { PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";
import { usePermissions } from "../../redux/slices/permissionsSlice";
import { FEATURE_CODES } from "../../util/featureCodes";
import Header from "../Header";
import LeavesSummary from "../LeavesSummary";
import LeftNavBar from "../LeftNavBar";
import PageHeader from "../PageHeader";
import TotalLeavesHistory from "../TotalLeavesHistory";
import "./index.css";
// import PopupModal from "../PopupModal";
import { PageHeaderName } from "../../StyledCss/styledComponents";

const LeavesOverviewManagement = () => {
  const [activeTab, setActiveTab] = useState("All History");
  // const [isWarningModal, setIsWarningModal] = useState(false);
  // const [refetchData, setRefetchData] = useState(false);
 

  const pageTabsList = [
    {
      id: 1,
      name: "All History",
      permissionCode: FEATURE_CODES.LEAVE_ALL_HISTORY_VIEW,
    },
    {
      id: 2,
      name: "Summary",
      permissionCode: FEATURE_CODES.LEAVE_SUMMARY_VIEW,
    },
  ];
  const { hasPermission } = usePermissions();
  const orgDetails = JSON.parse(localStorage.getItem("org"));
  const { primaryColor } = orgDetails;

  const tabs = () => (
    <div className="d-flex align-items-center leaves-tab-container">
      {pageTabsList.map(
        (eachTab) =>
          hasPermission(eachTab.permissionCode) && (
            <button
              style={
                activeTab === eachTab.name
                  ? {
                    color: primaryColor,
                    borderBottom: `3px solid ${primaryColor}`,
                  }
                  : {}
              }
              className={
                activeTab === eachTab.name ? "leave-active-tab" : "leave-tab"
              }
              onClick={() => setActiveTab(eachTab.name)}
              key={eachTab.id}
            >
              {eachTab.name}
            </button>
          )
      )}
    </div>
  );

  // Content is gated the same way the tab button is (not just hidden by the
  // tab bar) — guards against activeTab ever pointing at a tab the current
  // user isn't permitted to see.
  const renderActiveTabPage = () => {
    switch (activeTab) {
      case "All History":
        return (
          hasPermission(FEATURE_CODES.LEAVE_ALL_HISTORY_VIEW) && <TotalLeavesHistory />
        );
      case "Summary":
        return (
          hasPermission(FEATURE_CODES.LEAVE_SUMMARY_VIEW) && <LeavesSummary />
        );
      default:
        return null;
    }
  };





  return (
    <>
      <Header />
      <div className="d-flex">
        <LeftNavBar />
        <div className="leaves-req-hist-container">
          <PageHeader>
            <PageHeaderName>Leave Overview Management</PageHeaderName>
          </PageHeader>
          <div className="page-content-container">
            {tabs()}
            {renderActiveTabPage()}


          </div>
        </div>
      </div>
    </>
  );
};

export default LeavesOverviewManagement;
